import { WSIcons } from "../../commonFunctions/iIcons";

export const getMenu: any = (userType: string) => {
  return {
    staticMenu:
      userType === "accountant"
        ? [
          {
            id: 101,
            label: "Invoice",
            icon: WSIcons.Print,
            path: "/"
          },
          {
            id: 102,
            label: "Invoice List",
            icon: WSIcons.OverViewIcon,
            path: "/invoice/list"
          },

          {
            id: 105,
            label: "Product List",
            icon: WSIcons.ShoppingBagIcon,
            path: "/products/list"
          },
          {
            id: 106,
            label: "Category",
            icon: WSIcons.Category,
            path: "/category/list"
          },

          {
            id: 109,
            label: "Purchase & Expense",
            icon: WSIcons.Money,
            children: [
              { id: 110, label: "Purchase", path: "/purchase" },
              { id: 111, label: "Payment Out", path: "/payment-out/list" },
              // { id: 113, label: "Purchase Order", path: "/purchase-order/list" },
              { id: 112, label: "Expense", path: "/expense/list" },
              // { id: 114, label: "Debit", path: "/debit-note" }
            ]
          },
          {
            id: 115,
            label: "Cash & Bank",
            icon: WSIcons.ShakeHands,
            children: [
              { id: 116, label: "Bank Accounts", path: "/Bank-account/list" },
              { id: 117, label: "Cash In Hand", path: "/cash-in-hand/list" },
              { id: 118, label: "Loan Accounts", path: "/loan-account/list" }
            ]
          },

          {id: 120, label: "Shipping", icon: WSIcons.Shipping, path: "/shipping/list"},

          // {
          //   id: 102,
          //   label: "Parties",
          //   icon: WSIcons.AllInclusiveOutlinedIcon,
          //   children: [
          //     {
          //       id: 103,
          //       label: "Party Details",
          //       path: "/add-party"
          //     }
          //   ]
          // },
          // {
          //   id: 104,
          //   label: "Unit",
          //   icon: WSIcons.OverViewIcon,
          //   path: "/select-unit/list"
          // },

          // {
          //   id: 128,
          //   label: "Sale",
          //   icon: WSIcons.SettingsIcon,
          //   children: [
          //     { id: 129, label: "Sale Invoices", path: "/add/sale" },
          //     { id: 130, label: "Estimate/Quotation", path: "/add/estimate" },
          //     { id: 131, label: "Proforma Invoice", path: "/add/proforma" },
          //     { id: 132, label: "Sale Order", path: "/add/sale-order" },
          //     { id: 133, label: "Payment In", path: "/add/payment-in" },
          //     { id: 134, label: "Delivery Challan", path: "/add/delivery-challan" },
          //     { id: 135, label: "Sale Return/Credit Note", path: "/add/credit-note" },
          //     { id: 136, label: "Other Income", path: "/add/other-income" },
          //     // { id: 137, label: "Vyapar POS", path: "/add/vyapar-pos" }
          //   ]
          // },
          // {
          //   id: 138,
          //   label: "Other Products",
          //   icon: WSIcons.OverViewIcon,
          //   path: "/products"
          // }
        ]
        : [
          {
            id: 101,
            label: "Invoice",
            icon: WSIcons.Print,
            path: "/"
          },
          {
            id: 102,
            label: "Invoice List",
            icon: WSIcons.OverViewIcon,
            path: "/invoice/list"
          },

          {
            id: 105,
            label: "Product List",
            icon: WSIcons.ShoppingBagIcon,
            path: "/products/list"
          },
          {
            id: 106,
            label: "Category List",
            icon: WSIcons.Category,
            path: "/category/list"
          },


          {
            id: 109,
            label: "Purchase & Expense",
            icon: WSIcons.Money,
            children: [
              { id: 110, label: "Purchase", path: "/purchase/list" },
              { id: 111, label: "Payment Out", path: "/payment-out/list" },
              // { id: 113, label: "Purchase Order", path: "/purchase-order/list" },
              { id: 112, label: "Expense", path: "/expense/list" },
              // { id: 114, label: "Debit", path: "/debit-note" }
            ]
          },
          {
            id: 115,
            label: "Cash & Bank",
            icon: WSIcons.ShakeHands,
            children: [
              { id: 116, label: "Bank Accounts", path: "/Bank-account/list" },
              { id: 117, label: "Cash In Hand", path: "/cash-in-hand/list" },
              { id: 118, label: "Loan Accounts", path: "/loan-account/list" }
            ]
          },
          {
            id: 103,
            label: "Vendor",
            icon: WSIcons.Store,
            path: "/party/list"
          },

          {id: 120, label: "Shipping", icon: WSIcons.Shipping, path: "/shipping/list"},

          {
            id: 104,
            label: "Reports",
            icon: WSIcons.reportIcon,
            path: "/reports"
          },

          {
            id: 119,
            label: "Users",
            icon: WSIcons.UserGroup,
            path: "/user/list"
          },

          // {
          //   id: 104,
          //   label: "Unit",
          //   icon: WSIcons.OverViewIcon,
          //   path: "/select-unit/list"
          // },

          // {
          //   id: 104,
          //   label: "Unit",
          //   icon: WSIcons.OverViewIcon,
          //   path: "/select-unit/list"
          // },

          // {
          //   id: 120,
          //   label: "Settings",
          //   icon: WSIcons.SettingsIcon,
          //   children: [
          //     { id: 121, label: "General", path: "/settings/general" },
          //     { id: 122, label: "Transactions", path: "/settings/transaction" },
          //     { id: 123, label: "Taxes & GST", path: "/settings/tax-gst" },
          //     { id: 124, label: "Party", path: "/settings/party" },
          //     { id: 125, label: "Items", path: "/settings/items" },
          //     { id: 126, label: "Accounting", path: "/settings/accounting" },
          //     { id: 127, label: "Transaction Message", path: "/settings/transactionmessage" },
          //     {
          //       id: 107,
          //       label: "Business Details",
          //       path: "/settings/business-details"
          //     },
          //   ]
          // },
          // {
          //   id: 128,
          //   label: "Sale",
          //   icon: WSIcons.SettingsIcon,
          //   children: [
          //     { id: 129, label: "Sale Invoices", path: "/sales/list" },
          //     { id: 130, label: "Estimate/Quotation", path: "/add/estimate" },
          //     { id: 131, label: "Proforma Invoice", path: "/add/proforma" },
          //     { id: 132, label: "Sale Order", path: "/add/sale-order" },
          //     { id: 133, label: "Payment In", path: "/add/payment-in" },
          //     { id: 134, label: "Delivery Challan", path: "/add/delivery-challan" },
          //     { id: 135, label: "Sale Return/Credit Note", path: "/add/credit-note" },
          //     { id: 136, label: "Other Income", path: "/add/other-income" },
          //     // { id: 137, label: "Vyapar POS", path: "/add/vyapar-pos" }
          //   ]
          // },
          // {
          //   id: 138,
          //   label: "Other Products",
          //   icon: WSIcons.OverViewIcon,
          //   path: "/products"
          // }
        ]
  };
};